import React from 'react';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import MenuBar from '../MenuBar/MenuBar';

const ContactUs = () => {
    return (
        <div>
            <MenuBar></MenuBar>
            <Contact></Contact>
            <Footer></Footer>
        </div>
    );
};

export default ContactUs;